module.exports = __webpack_public_path__ + "trail_yellow.svg";